module.exports = __webpack_public_path__ + "img/asiapool_qrcode.325d186e.jpg";